import { cn } from "@/lib/utils";

interface SpinnerProps {
  className?: string;
}

const Spinner = ({ className }: SpinnerProps) => {
  return (
    <img
      width="20"
      height="20"
      src="loader.svg"
      alt="loading"
      className={cn("animate-spin-slow", className)}
    />
  );
};

export default Spinner;
